<template>
  <v-row no-gutters >
    <v-col :style="{ 
      marginLeft: (item.indentLevel && !item.node?.drilldown?.expanded ? 8 : 0) + (item.indentLevel * 25) + 'px', 
      maxWidth: 'calc(100% - ' + ((item.indentLevel && !item.node?.drilldown?.expanded ? 8 : 0) + (item.indentLevel * 25)) + 'px)' }">
      <v-row no-gutters>
        <v-col>
          <DimensionDisplay
            :item="item"
            :catalogueDocType="catalogueDocType"
            :indentNode="indentNode"
            :searchTerms="searchTerms"
            :hideNodeActions="hideNodeActions"
            @openDocActionsMenuContext="
              $emit('openDocActionsMenuContext', $event)
            "
            @openDocument="$emit('openDocument', $event)"
            @copyDocument="$emit('copyDocument', $event)"
            @showMatches="$emit('showMatches')"
            @selectJob="$emit('selectJob')"
            @doMenuAction="$emit('doMenuAction', $event)"
            @nodeSelected="$emit('nodeSelected', item.node)"
            @viewNodeDoc="$emit('viewNodeDoc', $event, item)"
            @saveDescriptor="$emit('saveDescriptor', ...arguments)"
          >
          </DimensionDisplay>
        </v-col>
        <v-col v-if="item.valueRanges && item.valueRanges.length">
          <span v-for="(vr, vri) in item.valueRanges" :key="'vr' + vri" class="ml-4" :class="vr.cssClass">
              <v-icon small v-if="vr.valueIcon">{{vr.valueIcon}}</v-icon>
            {{ vr.title }}
          </span>
        </v-col>
        <template v-if="item.valueGroups && item.valueGroups.length">
          <v-col v-for="(vg, vgi) in item.valueGroups" :key="'vg' + vgi">
            <span v-for="(v, vi) in vg.values" :key="'vg' + vgi + 'v' + vi" class="ml-4" :class="vg.cssClass">
              <v-icon small v-if="vg.valueIcon">{{vg.valueIcon}}</v-icon>
              {{ v.value }} {{ v.title }}
            </span>
          </v-col>
        </template>
      </v-row>
      <v-row v-if="item.nestedColumns?.length" no-gutters>
        <v-col>
          <template v-for="(nc, nci) in item.nestedColumns">
            <span
              v-if="nc.valueDisplayType === 'chip'"
              :key="'hhc_nc' + nci"
              :class="nc.cssClass"
            ><v-icon small v-if="nc.valueIcon">{{nc.valueIcon}}</v-icon>
              {{ nc.title }}
            </span>
            <div v-else :key="'hhc_nc' + nci" :class="nc.cssClass">
            <v-icon small v-if="nc.valueIcon">{{nc.valueIcon}}</v-icon>
              {{ nc.title }}
            </div>
          </template>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DimensionDisplay from "@/components/jobArchitecture/DimensionDisplay";

export default {
  name: "RowHeader",
  components: {
    DimensionDisplay,
  },
  props: {
    item: { type: Object, required: false },
    catalogueDocType: { type: Object, required: false },
    indentNode: Boolean,
    searchTerms: { type: [], required: false },
    hideNodeActions: { type: Boolean, required: false },
  },
  data: function () {
    return {
      response: null,
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/vars";
